var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
// SPDX-FileCopyrightText: 2026 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { gql } from "@apollo/client";
// The full callback URL of an account at the public webhook component, or why
// there is none (one reason, from the backend's callback_readiness).
export var MESSAGING_ACCOUNT_CALLBACK_URL = gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    query MessagingAccountCallbackUrl($accountId: uuid!) {\n        messaging_account_callback_url(account_id: $accountId) {\n            callback_url\n            reason\n        }\n    }\n"], ["\n    query MessagingAccountCallbackUrl($accountId: uuid!) {\n        messaging_account_callback_url(account_id: $accountId) {\n            callback_url\n            reason\n        }\n    }\n"])));
var templateObject_1;
